/*
 * kult-b2b-mischung-cart.js — Bürokaffee-Konfigurator, Weg „einmalig + Kult-Etikett“ direkt in den Warenkorb (11.10.2026).
 * Läuft nur an <kult-b2b-mischung data-cart-once> (sections/kult-b2b-mischung.liquid). assets/kult-b2b-mischung.js setzt
 * data-path="cart|request" (updatePath) und rechnet die Tütenzahl (cartBags); CSS (kult-b2b-mischung.css) zeigt im Weg
 * „cart“ die Buttons [data-mischung-cart] statt „Anfrage absenden“ und blendet Schritt 5 „Ihre Kontaktdaten“ aus.
 * Klick auf [data-mischung-cart]:
 *  - Variante aus der gewählten Kaffee-Kachel (data-cart-variants „id:Größe:Zubereitung:lieferbar;…“ aus
 *    snippets/kult-b2b-mischung-choices.liquid, ohne Abruf von /products/…js): Größe „500 g“ bzw. „1 kg“ (Gebinde) und
 *    Zubereitung über window.KultGrind.forMethod (Vollautomat/Siebträger → Ganze Bohne, Filter → Handfilter; Ersatz
 *    Ganze Bohne), Menge = Tütenzahl;
 *  - sichtbare Eigenschaften „Bürokaffee: Einmalige Bestellung“ und „Zubereitung“ (Wahl im Schritt 1), versteckt
 *    _kultb2b_quelle = buerokaffee: Firmenposition für assets/kult-b2b-reset.js (Attribut bleibt auch auf Privatkunden-Seiten);
 *  - Warenkorb-Attribut „Firmenbestellung“ = „Ja“ wie assets/kult-b2b-shop.js: Warenkorb im Firmenmodus, Netto-Summen
 *    (snippets/kult-cart-b2b-summary.liquid), Rechnung mit MwSt.-Ausweis, Bestell-Tag firmenbestellung über die App;
 *  - danach "kult:cart:add" { cart, title } (assets/kult-cart.js; im Firmenmodus öffnet sich die Warenkorbseite ?view=b2b).
 * Bewusst ohne die Eigenschaft _kultb2b selbst: sie steht für Präsent-Gruppen (Box-Zeile, feste Anzahl, eigene Zusammenfassung,
 * Versandarten der Kasse in apps/kult-b2b-checkout); der Bürokaffee läuft wie Kaffee aus dem Firmenkunden-Shop.
 * Fehler erscheinen in [data-mischung-cart-error] (role="alert"); Sperre über aria-busy und disabled.
 * Eigenschaft ohne kg-Angabe (11.10.2026): Die Menge ergibt sich aus Stückzahl × Tüte (Variante „1 kg“ bzw. „500 g“). Eine kg-Angabe
 * in der Eigenschaft veraltete bei jeder Mengenänderung im Warenkorb (Drawer, Warenkorbseite); ein Nachschreiben per /cart/change.js
 * hinge an jedem Mengen-Weg und änderte den Zeilen-Schlüssel. So bleibt die Zeile immer stimmig, und gleiche Bestellungen
 * landen auf derselben Zeile.
 * Kauf-Zusammenfassung (Vorgabe Philip 11.10.2026, snippets/kult-b2b-mischung-buy.liquid): auf "kult:mischung:path" (Ende von
 * updatePath() in assets/kult-b2b-mischung.js) Position, Einzelpreis netto, Zwischensumme netto, MwSt., Gesamt brutto und Grundpreis
 * aus der Variante, die der Button in den Warenkorb legt. Rechnung wie Shopify (Preise inkl. MwSt.): brutto = Menge × Preis,
 * MwSt. = round(brutto × Satz / (100 + Satz)), netto = brutto − MwSt.; Einzel- und Grundpreis netto = round(brutto × 100 / (100 + Satz))
 * wie snippets/kult-b2b-net. Am Konfigurator data-buy="ready" (CSS blendet dann die Anfrage-Angaben aus), sonst ohne Attribut.
 */
(function () {
  'use strict';
  if (window.__kultMischungCart) return;
  window.__kultMischungCart = true;

  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var NUM2 = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var FALLBACK = 'Das hat leider nicht geklappt. Bitte versuchen Sie es noch einmal oder senden Sie uns eine Anfrage.';

  function grindFor(key) {
    var g = window.KultGrind && window.KultGrind.forMethod ? window.KultGrind.forMethod(key) : '';
    if (g) return g;
    return key === 'filter' ? 'Handfilter' : 'Ganze Bohne';
  }

  /* data-cart-variants → [{ id, size, grind, available, price (Cent brutto) }] */
  function variantsOf(tile) {
    return String(tile.getAttribute('data-cart-variants') || '').split(';').map(function (part) {
      var p = part.split(':');
      return p.length >= 4 ? { id: parseInt(p[0], 10), size: p[1], grind: p[2], available: p[3] === '1', price: parseInt(p[4], 10) || 0 } : null;
    }).filter(function (v) { return v && v.id; });
  }

  function eur(cents) { return NUM2.format(cents / 100) + '\u00a0€'; }

  /* Variante, die der Button in den Warenkorb legt, mit Tütenzahl; null ohne Kaffee oder passende Variante */
  function currentLine(app) {
    if (typeof app.hasCoffee === 'function' && !app.hasCoffee()) return null;
    var tile = app.coffee && app.coffee.tile;
    if (!tile || typeof app.cartBags !== 'function') return null;
    var bags = app.cartBags();
    var v = pickVariant(variantsOf(tile), bags.bag === 500 ? '500 g' : '1 kg', grindFor(app.brewerKey));
    return v ? { v: v, bags: bags, title: app.coffee.productTitle || app.coffee.title || '' } : null;
  }

  /* Kauf-Zusammenfassung [data-mischung-buy] füllen (nur im Weg „cart“) */
  function renderBuy(app) {
    var box = app.querySelector('[data-mischung-buy]');
    if (!box) return;
    var line = app.getAttribute('data-path') === 'cart' ? currentLine(app) : null;
    if (!line || !(line.v.price > 0)) {
      box.hidden = true;
      app.removeAttribute('data-buy');
      return;
    }
    var vat = parseFloat(box.getAttribute('data-vat')) || 7;
    var qty = line.bags.count;
    var gross = qty * line.v.price;
    var tax = Math.round((gross * vat) / (100 + vat));
    var net = gross - tax;
    var unitNet = Math.round((line.v.price * 100) / (100 + vat));
    var kgNet = Math.round(((line.v.price * 1000) / line.bags.bag) * 100 / (100 + vat));
    var bagName = typeof app.bagName === 'function' ? app.bagName(line.bags.bag) : (line.bags.bag === 500 ? '500-g-Tüte' : '1-kg-Tüte');
    var set = function (key, text) { var el = box.querySelector('[data-buy="' + key + '"]'); if (el) el.textContent = text; };
    set('pos', qty + ' × ' + bagName + ' ' + line.title + (app.brewer ? ', ' + app.brewer : ''));
    var label = app.getAttribute('data-label-kult') || 'Kult-Etikett';
    set('pos-note', label + ' · ' + eur(line.v.price) + ' brutto je Tüte · Grundpreis ' + eur(kgNet) + ' je kg netto' + (line.v.available ? '' : ' · derzeit nicht lieferbar'));
    set('unit', 'je ' + eur(unitNet) + ' netto');
    set('net', eur(net));
    set('vat', NUM2.format(vat).replace(/,00$/, ''));
    set('tax', eur(tax));
    set('gross', eur(gross));
    var round = box.querySelector('[data-buy="round"]');
    if (round) round.hidden = unitNet * qty === net;
    box.hidden = false;
    app.setAttribute('data-buy', 'ready');
  }

  function pickVariant(list, size, grind) {
    var find = function (g) { return list.filter(function (v) { return v.size === size && v.grind === g; })[0]; };
    return find(grind) || find('Ganze Bohne') || null;
  }

  function setBusy(app, busy) {
    app.querySelectorAll('[data-mischung-cart]').forEach(function (b) {
      b.disabled = busy;
      if (busy) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    });
  }

  function showError(app, text) {
    app.querySelectorAll('[data-mischung-cart-error]').forEach(function (el) {
      el.textContent = text || '';
      el.hidden = !text;
    });
  }

  function addToCart(app) {
    if (app.getAttribute('data-path') !== 'cart' || app.__kultCartBusy) return;
    if (typeof app.hasCoffee === 'function' && !app.hasCoffee()) return;
    var tile = app.coffee && app.coffee.tile;
    if (!tile) { showError(app, FALLBACK); return; }
    var bags = app.cartBags();
    var size = bags.bag === 500 ? '500 g' : '1 kg';
    var title = app.coffee.productTitle || app.coffee.title || '';
    var v = pickVariant(variantsOf(tile), size, grindFor(app.brewerKey));
    if (!v) { showError(app, FALLBACK); return; }
    if (!v.available) { showError(app, title + ' ist in dieser Größe gerade nicht lieferbar. Bitte wählen Sie ein anderes Gebinde oder senden Sie uns eine Anfrage.'); return; }
    var props = { _kultb2b_quelle: 'buerokaffee', 'Bürokaffee': 'Einmalige Bestellung' };
    if (app.brewer) props['Zubereitung'] = app.brewer;
    app.__kultCartBusy = true;
    setBusy(app, true);
    showError(app, '');
    fetch('/cart/add.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: [{ id: v.id, quantity: bags.count, properties: props }] }) })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error((data && (data.description || data.message)) || FALLBACK);
        });
      })
      .then(function () {
        return fetch('/cart/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ attributes: { Firmenbestellung: 'Ja' } }) });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('kult:cart:add', { detail: { cart: cart, title: title } }));
      })
      .catch(function (err) { showError(app, (err && err.message) || FALLBACK); })
      .then(function () { app.__kultCartBusy = false; setBusy(app, false); });
  }

  document.addEventListener('kult:mischung:path', function (e) {
    var app = e.target && e.target.closest ? e.target.closest('kult-b2b-mischung[data-cart-once]') : null;
    if (app) renderBuy(app);
  });
  /* Skript lädt nach dem ersten updatePath(): bestehende Konfiguratoren einmal nachziehen */
  document.querySelectorAll('kult-b2b-mischung[data-cart-once]').forEach(renderBuy);

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-mischung-cart]') : null;
    if (!btn) return;
    var app = btn.closest('kult-b2b-mischung[data-cart-once]');
    if (app) addToCart(app);
  });
})();
